<template>
    <div
        v-if="condition"
        class="help-text error-text mt-2 text-red"
    >
        <slot />
    </div>
</template>

<script>
    export default {
        name: 'InputError',

        props: {
            condition: {
                type: Boolean,
                default: false,
                required: true,
            },

        },
    };
</script>
